var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard design"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1182,
    transform: "translate(-888 -530)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003781",
    clipPath: "url(#clip0_474_6528)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 1066,
    transform: "translate(-568 -442)",
    fill: "#F5F7FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003820"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -528,
    y: -95,
    width: 670,
    height: 230,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003824"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -78.5,
    y: -31.5,
    width: 198,
    height: 139,
    rx: 7.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transfer Arrowl"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.25 20C39.25 23.7084 38.1503 27.3335 36.0901 30.4169C34.0298 33.5004 31.1014 35.9036 27.6753 37.3227C24.2492 38.7419 20.4792 39.1132 16.8421 38.3897C13.2049 37.6662 9.86399 35.8805 7.24176 33.2582C4.61952 30.636 2.83376 27.2951 2.11028 23.6579C1.38681 20.0208 1.75812 16.2508 3.17727 12.8247C4.59641 9.39856 6.99964 6.47021 10.0831 4.40994C13.1665 2.34966 16.7916 1.24999 20.5 1.24999C25.4728 1.24999 30.242 3.22543 33.7583 6.74174C37.2746 10.258 39.25 15.0272 39.25 20ZM3.00001 20C3.00001 23.4612 4.02637 26.8446 5.94929 29.7225C7.87221 32.6003 10.6053 34.8434 13.803 36.1679C17.0008 37.4924 20.5194 37.839 23.9141 37.1637C27.3088 36.4885 30.427 34.8218 32.8744 32.3744C35.3218 29.9269 36.9885 26.8087 37.6637 23.4141C38.339 20.0194 37.9924 16.5007 36.6679 13.303C35.3434 10.1053 33.1003 7.3722 30.2225 5.44928C27.3446 3.52635 23.9612 2.49999 20.5 2.49999C15.8587 2.49999 11.4075 4.34374 8.12564 7.62563C4.84375 10.9075 3.00001 15.3587 3.00001 20Z",
    fill: "#6563FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.5 20C35.5 11.7157 28.7843 5 20.5 5C12.2157 5 5.5 11.7157 5.5 20C5.5 28.2843 12.2157 35 20.5 35C28.7843 35 35.5 28.2843 35.5 20Z",
    fill: "#B2B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.9251 20.75C25.8683 20.8027 25.823 20.8665 25.792 20.9375C25.761 21.0085 25.745 21.0851 25.745 21.1625C25.745 21.24 25.761 21.3166 25.792 21.3876C25.823 21.4585 25.8683 21.5224 25.9251 21.575L27.2626 22.9125H12.3376C12.1818 22.9125 12.0323 22.9744 11.9222 23.0846C11.812 23.1948 11.7501 23.3442 11.7501 23.5C11.7501 23.6558 11.812 23.8053 11.9222 23.9154C12.0323 24.0256 12.1818 24.0875 12.3376 24.0875H27.2626L25.9251 25.425C25.8683 25.4777 25.823 25.5415 25.792 25.6125C25.761 25.6835 25.745 25.7601 25.745 25.8375C25.745 25.915 25.761 25.9916 25.792 26.0626C25.823 26.1335 25.8683 26.1974 25.9251 26.25C26.035 26.3584 26.1832 26.4192 26.3376 26.4192C26.492 26.4192 26.6402 26.3584 26.7501 26.25L29.0751 23.9125C29.1491 23.8781 29.2103 23.8213 29.2501 23.75C29.2834 23.6797 29.3007 23.6028 29.3007 23.525C29.3007 23.4472 29.2834 23.3703 29.2501 23.3C29.2279 23.2265 29.1844 23.1613 29.1251 23.1125L26.7501 20.75C26.6402 20.6416 26.492 20.5809 26.3376 20.5809C26.1832 20.5809 26.035 20.6416 25.9251 20.75ZM14.2501 13.75L11.9251 16.0875C11.8511 16.1219 11.7899 16.1788 11.7501 16.25C11.7191 16.321 11.7031 16.3976 11.7031 16.475C11.7031 16.5525 11.7191 16.6291 11.7501 16.7C11.7723 16.7735 11.8158 16.8388 11.8751 16.8875L14.2501 19.25C14.36 19.3584 14.5082 19.4192 14.6626 19.4192C14.817 19.4192 14.9652 19.3584 15.0751 19.25C15.1319 19.1974 15.1772 19.1335 15.2082 19.0626C15.2392 18.9916 15.2552 18.915 15.2552 18.8375C15.2552 18.7601 15.2392 18.6835 15.2082 18.6125C15.1772 18.5415 15.1319 18.4777 15.0751 18.425L13.7376 17.0875H28.6626C28.8184 17.0875 28.9678 17.0256 29.078 16.9154C29.1882 16.8053 29.2501 16.6558 29.2501 16.5C29.2501 16.3442 29.1882 16.1948 29.078 16.0846C28.9678 15.9744 28.8184 15.9125 28.6626 15.9125L13.7376 15.9125L15.0751 14.575C15.1403 14.5237 15.194 14.4591 15.2324 14.3855C15.2709 14.3119 15.2933 14.231 15.2983 14.1482C15.3032 14.0653 15.2905 13.9823 15.261 13.9047C15.2315 13.8271 15.1859 13.7566 15.1272 13.6979C15.0685 13.6392 14.998 13.5936 14.9204 13.5641C14.8428 13.5346 14.7598 13.5219 14.6769 13.5268C14.5941 13.5318 14.5132 13.5542 14.4396 13.5927C14.366 13.6311 14.3014 13.6848 14.2501 13.75Z",
    fill: "#6563FF"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -78.5,
    y: -31.5,
    width: 198,
    height: 139,
    rx: 7.5,
    stroke: "#F2F2F2"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_474_6528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1120,
    height: 1066,
    fill: "white",
    transform: "translate(-568 -442)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.df7fa447cce4473ac0dcb059c0fc1e1e.svg";
export { ForwardRef as ReactComponent };